module.exports = __webpack_public_path__ + "img/hinamori.b0960614.jpg";